import React from 'react';
import Grid from '@mui/material/Grid';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { dateFnsFormat } from 'constants';
import { stringAvatar } from 'utils/commonUtils';
import {
  StudentHeaderGrid,
  StudentHeaderLeftGrid,
  AvatarEditButton,
  AvatarMD,
} from 'components/Ui/styled';
import Icon from '@mui/material/Icon';

const StudentHeader = () => {
  const studentDetails = useSelector((state) => state.studentDetails?.item);

  const studentName = `${studentDetails?.firstName} ${studentDetails?.lastName}`;

  const mostRecentActivityAt =
    studentDetails &&
    format(
      new Date(studentDetails?.attendanceData?.mostRecentActivityAt),
      dateFnsFormat
    );

  return (
    <>
      <StudentHeaderGrid container spacing={3}>
        <StudentHeaderLeftGrid item>
          <MDBox position="relative" height="max-content" mx="auto">
            <AvatarMD size="xl" shadow="sm" {...stringAvatar(studentName)} />
            <MDBox position="absolute" right={0} bottom={0} mr={1.7}>
              <AvatarEditButton
                variant="gradient"
                color="dark"
                size="small"
                iconOnly
              >
                <Icon>edit</Icon>
              </AvatarEditButton>
            </MDBox>
          </MDBox>
          <MDBox height="100%" mt={0.5} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              {studentDetails?.firstName} {studentDetails?.lastName}
            </MDTypography>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Grade {studentDetails?.grade}
            </MDTypography>
            <MDTypography variant="h5" fontWeight="medium">
              ID : {studentDetails?.studentId}
            </MDTypography>
          </MDBox>
        </StudentHeaderLeftGrid>
        <Grid item>
          <MDBox height="100%" mt={0.5} lineHeight={1}>
            <MDTypography variant="body2" fontWeight="regular">
              Last login
            </MDTypography>
            <MDTypography variant="body2" fontWeight="regular">
              {mostRecentActivityAt || 'N/A'}
            </MDTypography>
          </MDBox>
        </Grid>
      </StudentHeaderGrid>
    </>
  );
};

export default StudentHeader;
